var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-optional-link',{attrs:{"disabled":!_vm.link ? true : false,"to":_vm.link}},[_c('div',{class:`BgNavigation__button`},[_c('BgIcon',{class:`BgNavigation__icon`,attrs:{"name":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }